import React, { useEffect, useState } from "react";
import "../Manage Projects/viewProjects.css";
import SearchBar from "../Main/searchBar";
import { Link, useParams } from "react-router-dom";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { DateToLocale, ToFirstCapital } from "../../Utils/helpers";
import "./siteVisit.css";
import { icons } from "../../icons";
import { viewSiteVisit } from "../../Redux/Actions/siteVisitActions";
import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ViewSiteVisit = () => {
  const { id } = useParams();
  const { siteVisit } = useSelector((state) => state.siteVisit);
  const dispatch = useDispatch();

  const [tripStatus, setTripStatus] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [isUpdating, setIsUpdating] = useState(false); // Loader state

  useEffect(() => {
    dispatch(viewSiteVisit(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (siteVisit?.data?.trip_status) {
      setTripStatus(siteVisit.data.trip_status);
    }
  }, [siteVisit]);

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    setShowConfirm(true);
  };

  const confirmStatusChange = async () => {
    setIsUpdating(true); // Start loader
    setShowConfirm(false);

    try {
      await axios.post(`${BASE_URL}/site-visit/update`, {
        id: siteVisit?.data?._id,
        status: selectedStatus,
      });
      toast.success("Status updated successfully!");
      // Refetch updated data to re-render component without full reload
      await dispatch(viewSiteVisit(id));
      setTripStatus(selectedStatus); // Update local state after reload
    } catch (error) {
      toast.error("Error updating status");
    } finally {
      setIsUpdating(false); // Stop loader
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "minmax(60px, auto)",
      }}
      className="padding-20 gap-10 grid-container"
    >
      <div style={{ gridColumn: "3/8" }}>
        <SearchBar style={{ width: "max-content" }} />
      </div>

      <div
        className="back-icon margin-0 gap-10 align-center flex-container"
        style={{ gridColumn: "span 7" }}
      >
        <Link to="/site_visit">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div>
          <h3>{siteVisit?.data?.ride_type}</h3>
          <h4 style={{ position: "relative", top: "-10px" }}>
            Site Visit / List / View
          </h4>
        </div>
      </div>

      <div className="overall-container" style={{ opacity: isUpdating ? 0.6 : 1 }}>
        <div
          style={{ backgroundColor: " rgba(255, 255, 255, 0.16)" }}
          className="flex-container flex-justify-between border-24 align-center padding-20"
        >
          {/* Project Info */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Project Name
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {siteVisit?.data?.project?.project_name || "No Data"}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Project Address
              </span>
              <h2 className="h2-column max-width-view">
                {siteVisit?.data?.project?.street_address || "No Data"}
              </h2>
            </div>
          </div>
          <hr className="project_hr" />

          {/* User Info */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                User Name
              </span>
              <h2 className="h2-column">
                {siteVisit?.data?.user?.name || "No Data"}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                User Email
              </span>
              <h2 className="h2-column">
                {siteVisit?.data?.user?.email || "0"}
              </h2>
            </div>
          </div>
          <hr className="project_hr" />

          {/* User Contact & Status */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                User Contact Number
              </span>
              <h2 className="h2-column">
                {`${siteVisit?.data?.user?.country_code} ${siteVisit?.data?.user?.contact_number}` ||
                  "No Data"}
              </h2>
            </div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Status
              </span>
              <h2 className="h2-column">{ToFirstCapital(siteVisit?.data?.status)}</h2>
            </div>
          </div>
          <hr className="project_hr" />

          {/* Site Visit By */}
          <div>
            <div className="flex-container flex-column">
              <span className="span-column" style={{ color: "#999" }}>
                Site Visit By
              </span>
              <h2 className="h2-column" style={{ color: "white" }}>
                {ToFirstCapital(siteVisit?.data?.site_visit_by) || "No Data"}
              </h2>
            </div>
            {siteVisit?.data?.site_visit_by !== "self" && (
              <div className="flex-container flex-column">
                <span className="span-column" style={{ color: "#999" }}>
                  Ride Type
                </span>
                <h2 className="h2-column">
                  {ToFirstCapital(siteVisit?.data?.ride_type) || "No Data"}
                </h2>
              </div>
            )}
          </div>
          <hr className="project_hr" />

          {/* Ride Type, Distance, Estimated Price -> only if NOT Self */}
          {siteVisit?.data?.site_visit_by !== "self" && (
            <>
              <div>
                <div className="flex-container flex-column">
                  <span className="span-column" style={{ color: "#999" }}>
                    Distance
                  </span>
                  <h2 className="h2-column" style={{ color: "white" }}>
                    {siteVisit?.data?.distance || "No Data"}
                  </h2>
                </div>
                <div className="flex-container flex-column">
                  <span className="span-column" style={{ color: "#999" }}>
                    Estimated Price
                  </span>
                  <h2 className="h2-column">
                    {siteVisit?.data?.estimated_price || "No Data"}
                  </h2>
                </div>
              </div>
              <hr className="project_hr" />
            </>
          )}
        </div>

        {/* Bottom Grid Info -> only if NOT Self */}
        {siteVisit?.data?.site_visit_by !== "self" && (
          <div className="flex-container flex-justify-around margin-h-10">
            {/* Pickup Address */}
            <div className="column2" style={{ flex: "1" }}>
              <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                <img src={icons["Date"]} alt="" />
                <div>
                  <span className="span_project" style={{ color: "#999" }}>
                    Pick Up Address
                  </span>
                  <h4 className="div-h4">
                    {siteVisit?.data?.pickup_address || "No Data"}
                  </h4>
                </div>
              </div>
            </div>
            {/* Pickup Date */}
            <div className="column3" style={{ flex: "1" }}>
              <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                <img src={icons["Category"]} alt="" />
                <div>
                  <span className="span_project" style={{ color: "#999" }}>
                    Pick Up Date & Time
                  </span>
                  <h4 className="div-h4">
                    {DateToLocale(siteVisit?.data?.pickup_date_time) || "No Data"}
                  </h4>
                </div>
              </div>
            </div>
            {/* Drop Address */}
            <div className="column4" style={{ flex: "1" }}>
              <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                <img src={icons["Tower"]} alt="" />
                <div>
                  <span className="span_project" style={{ color: "#999" }}>
                    Drop Off Address
                  </span>
                  <h4 className="div-h4">{siteVisit?.data?.drop_address || "No Tower"}</h4>
                </div>
              </div>
            </div>
            {/* Cab Type */}
            <div className="column5" style={{ flex: "1" }}>
              <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                <img src={icons["Area"]} alt="" />
                <div>
                  <span className="span_project" style={{ color: "#999" }}>
                    Cab Type
                  </span>
                  <h4 className="div-h4">
                    {ToFirstCapital(siteVisit?.data?.cab_type?.name) || "No Data"}
                  </h4>
                </div>
              </div>
            </div>
            {/* Round Trip */}
            <div className="column6" style={{ flex: "1" }}>
              <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                <img src={icons["Category"]} alt="" />
                <div>
                  <span className="span_project" style={{ color: "#999" }}>
                    Round Trip
                  </span>
                  <h4 className="div-h4">
                    {siteVisit?.data?.is_round_trip === true ? "Yes" : "No"}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Trip Status Dropdown (always visible) */}
        <div className="column7" style={{ flex: "1" }}>
          <div className="flex-container flex-column gap-10 padding-10" style={{ alignItems: "start" }}>
            <div>
              <span className="span_project" style={{ color: "#999" }}>
                Trip Status
              </span>
              <select
                value={tripStatus}
                onChange={handleStatusChange}
                className="div-h4"
                disabled={isUpdating}
                style={{
                  width: "100%",
                  padding: "8px",
                  borderRadius: "8px",
                  backgroundColor: "white",
                  color: "black",
                  border: "1px solid #ccc",
                  marginTop: "5px",
                  cursor: isUpdating ? "not-allowed" : "pointer",
                }}
              >
                <option value="" disabled>
                  Select Status
                </option>
                {["requested", "booked", "cancelled", "completed"].map((status) => (
                  <option key={status} value={status}>
                    {status.charAt(0).toUpperCase() + status.slice(1)}
                  </option>
                ))}
              </select>
              {isUpdating && <p style={{ color: "white", marginTop: "5px" }}>Updating status...</p>}
            </div>
          </div>
        </div>

        {/* Confirmation Modal */}
        {showConfirm && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 999,
            }}
          >
            <div
              className="modal-content"
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "12px",
                minWidth: "300px",
                textAlign: "center",
              }}
            >
              <p style={{ color: "black"}}>
                Are you sure you want to change status to "
                {selectedStatus.charAt(0).toUpperCase() + selectedStatus.slice(1)}
                "?
              </p>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <button
                  onClick={confirmStatusChange}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "green",
                    color: "white",
                  }}
                >
                  Yes
                </button>
                <button
                  onClick={() => setShowConfirm(false)}
                  disabled={isUpdating}
                  style={{
                    padding: "8px 16px",
                    borderRadius: "8px",
                    cursor: isUpdating ? "not-allowed" : "pointer",
                    backgroundColor: "red",
                    color: "white",
                  }}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Service Provider Details -> only if NOT Self */}
        {siteVisit?.data?.site_visit_by !== "self" && (
          <>
            <h2
              style={{
                color: "white",
                margin: "20px 0 10px 10px",
                fontSize: "20px",
                fontWeight: "600",
              }}
            >
              Service Provider Details
            </h2>
            <div className="flex-container flex-justify-around margin-h-10 margin-top-20">
              {/* Company */}
              <div className="column1" style={{ flex: "1" }}>
                <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                  <img src={icons["Name"]} alt="" />
                  <div>
                    <span className="span_project" style={{ color: "#999" }}>
                      Company Name
                    </span>
                    <h4 className="div-h4">
                      {siteVisit?.data?.service_provider?.company_name || "No Data"}
                    </h4>
                  </div>
                </div>
              </div>
              {/* Contact */}
              <div className="column2" style={{ flex: "1" }}>
                <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                  <img src={icons["Phone"]} alt="" />
                  <div>
                    <span className="span_project" style={{ color: "#999" }}>
                      Contact Number
                    </span>
                    <h4 className="div-h4">
                      {`${siteVisit?.data?.service_provider?.country_code} ${siteVisit?.data?.service_provider?.contact_number}` ||
                        "No Data"}
                    </h4>
                  </div>
                </div>
              </div>
              {/* Email */}
              <div className="column3" style={{ flex: "1" }}>
                <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                  <img src={icons["Email"]} alt="" />
                  <div>
                    <span className="span_project" style={{ color: "#999" }}>
                      Email
                    </span>
                    <h4 className="div-h4">{siteVisit?.data?.service_provider?.email || "No Data"}</h4>
                  </div>
                </div>
              </div>
              {/* Address */}
              <div className="column4" style={{ flex: "1" }}>
                <div className="flex-container gap-10 padding-10" style={{ alignItems: "start" }}>
                  <img src={icons["Tower"]} alt="" />
                  <div>
                    <span className="span_project" style={{ color: "#999" }}>
                      Address
                    </span>
                    <h4 className="div-h4 max-width-view">
                      {siteVisit?.data?.service_provider?.address || "No Data"}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ViewSiteVisit;
